<div class="row position-relative">
  <div class="col-12 col-lg-2">
    <label class="text-white lb-header" for="cpName">Campaign Name <i class="required-symbol">*</i> </label>
  </div>
  <div class="col-12 col-lg-10">
    <input name="cpName" id="cpName" #cpn maxlength="256" class="w-100 p-calendar-w-btn crg-base-input" [(ngModel)]="campaignName"/>
  </div>
  <div class="rest-hint">{{cpn.value.length}}/256</div>
</div>
<!--<div class="row">
  <div class="col-auto">
    <select
      class="form-control selector"
      name="ddlEmailType"
      [(ngModel)]="data.emailType"
    >
      <option [ngValue]="item.value" *ngFor="let item of emailTypes">
        {{ item.name }}
      </option>
    </select>
  </div>
</div>-->
<div class="row mt-4">
  <div class="col-12 col-lg-2 ">
    <label class="text-white lb-header">From <i class="required-symbol">*</i></label>
  </div>
  <div class="col-12 col-lg-10">
    <select
      style="min-width: 200px"
      class="selector p-calendar-w-btn crg-base-input text-white"
      name="ddlEmailType"
      [(ngModel)]="data.emailType"
    >
      <option [ngValue]="item.value" *ngFor="let item of emailTypes">
        {{ item.name }}
      </option>
    </select>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2 vertical-line">
    <label class="mb-3 lb-header text-white" style="height: 24px">To<i class="required-symbol">*</i></label>
  </div>
  <div class="col-lg-10 col-12">
    <span class="fx-radio text-white mb-2">
      <input
        type="radio"
        name="accountType"
        [value]="1"
        checked
        (change)="onChangeAcc()"
      />
      <span class="checkmark"></span>
      <label>Traders</label>
    </span>
    <span class="fx-radio text-white">
      <input
        type="radio"
        name="accountType"
        [value]="2"
        (change)="onChangeAcc()"
      />
      <span class="checkmark"></span>
      <label>IBs</label>
    </span>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2 vertical-line">
    <label class="mb-3 lb-header text-white" style="height: 24px">In <i class="required-symbol">*</i></label>
  </div>
  <div class="col-lg-10 col-12">
    <div>
      <span class="fx-radio text-white mb-2">
        <input type="radio" name="countryType" [value]="1" checked/>
        <span class="checkmark"></span>
        <label>All Countries</label>
      </span>

      <span class="fx-radio text-white mb-2">
        <input type="radio" name="countryType" [value]="2"/>
        <span class="checkmark"></span>
        <label>Japan</label>
      </span>

      <span class="fx-radio text-white">
        <input type="radio" name="countryType" [value]="3"/>
        <span class="checkmark"></span>
        <label>Others than Japan</label>
      </span>
    </div>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2">
    <label class="text-white lb-header">Who</label>
  </div>
  <div class="col-12 col-lg-10">
    <div class="{{ isDisableWithoutDeposit ? 'ignore-click' : '' }}">
      <span class="fx-square-check text-white">
        <input
          type="checkbox"
          name="withdrawDeposit"
          value="1"
          [checked]="!isDisableWithoutDeposit"
        />
        <span class="checkmark"></span>
        <label>Never deposited</label>
      </span>
    </div>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2"></div>
  <div class="col-12 col-lg-10">
    <button
      mat-button
      class="btn bg-common"
      (click)="
        isCondition = true;
        data.keyword = '';
        pageInfo.pageIndex = 1;
        postPreviewEmail()
      "
    >
      Preview
    </button>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2"></div>
  <div class="col-12 col-lg-10">
    <ng-container *ngIf="listPreview.length > 0">
      <div class="row">
        <div class="col">
          <label class="text-white">{{ "Preview All Email" | uppercase }}</label>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="input-group search-group">
            <input
              type="text"
              class="form-control text-black"
              name="keyword"
              placeholder="Search Transaction"
              [(ngModel)]="data.keyword"
              (keyup)="searchEmail($event)"
            />
            <div class="input-group-append">
              <button
                class="btn bg-common"
                type="button"
                (click)="searchEmail('click')"
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="table-responsive mt-3">
            <table class="rox-table table-bordered bg-dark w-100">
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">User Name</th>
                  <th class="text-center">User Name (JP)</th>
                  <th class="text-center">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                let item of listPreview
                  | paginate
                    : {
                        id: 'email_marketing_preview',
                        itemsPerPage: pageInfo.pageSize,
                        currentPage: pageInfo.pageIndex,
                        totalItems: pageInfo.totalRecord
                      }
              "
                >
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">{{ item.getUserName() }}</td>
                  <td class="text-center">{{ item.getUserNameJP() }}</td>
                  <td class="text-center">{{ item.email }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="email_marketing_preview"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div class="row mt-4 position-relative">
  <div class="col-12 col-lg-2">
    <label class="text-white lb-header" for="subject">Subject <i class="required-symbol">*</i> </label>
  </div>
  <div class="col-12 col-lg-10">
    <input name="sub" id="subject" #sj class="w-100 p-calendar-w-btn crg-base-input" maxlength="256" [(ngModel)]="data.sub"/>
  </div>
  <div class="rest-hint">{{sj.value.length}}/256</div>
</div>

<div class="row mt-4">
  <div class="col-12 col-lg-2">
    <label class="text-white lb-header" for="areaOther">Content <i class="required-symbol">*</i> </label>
  </div>
  <div class="col-12 col-lg-10">
    <textarea class="form-control" name="content" id="areaOther"></textarea>
    <div id="fill-content-other" class="d-none"></div>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2">
    <label class="text-white lb-header">Send Date</label>
  </div>
  <div class="col-12 col-lg-10">
    <p-calendar
      name="schedulerDate"
      [(ngModel)]="schedulerDate"
      required
      #datePicker="ngModel"
      [placeholder]="'dd/mm/yyyy HH:mm'"
      [dateFormat]="'dd/mm/yy'"
      [timeOnly]="false"
      [showIcon]="true"
      [showSeconds]="false"
      [minDate]="minDate"
      [showTime]="true"
      inputStyleClass="form-control past-picker-disabled"
      class="schedule_time_picker past-picker-disabled"
    ></p-calendar>
    <br>
    <p class="text-red mb-0 mt-2">*Email will be sent automatically at the time scheduled above if set.</p>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 col-lg-2"></div>
  <div class="col-12 col-lg-10">
    <button mat-button class="btn bg-common" (click)="postSendEmail()">Save & Send</button>
  </div>
</div>
